import { RefObject, useEffect } from 'react'

import {
  disableBodyScroll,
  enableBodyScroll,
  BodyScrollOptions,
} from 'body-scroll-lock'

// Adds overflow hidden to the body element
// to prevent scrolling of the page when modal is open
export const useBodyScrollLock = (
  ref: RefObject<HTMLElement | Element | null> | null,
  opts?: BodyScrollOptions,
) => {
  useEffect(() => {
    const element = ref?.current

    if (element) {
      disableBodyScroll(element, opts)
    }

    return () => {
      if (element) {
        enableBodyScroll(element)
      }
    }
  }, [opts, ref])
}
